import { render, staticRenderFns } from "./ztsz-zdgz.vue?vue&type=template&id=210bfcd1&"
import script from "./ztsz-zdgz.vue?vue&type=script&lang=js&"
export * from "./ztsz-zdgz.vue?vue&type=script&lang=js&"
import style0 from "./ztsz-zdgz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports